export default __webpack_public_path__ + "static/media/card1-4.50afb2cc.jpg";